// Node Modules
import { nanoid } from 'nanoid';
import { RichText } from 'prismic-reactjs';
// Components
import Program from './sub-components/Program';

// Themes
import theme from '@/themes/index';

const Programs = ({
  content: {
    programsTitle,
    programsSubtitle,
    programsIntro,
    programs, 
  },
  alternatePosition = false,
  showTitle = true,
  showInformationCardTitle = false,
  isDesktop,
}) => {

  const getInfoContainerStyle = index => {
    if(alternatePosition) {
      return isDesktop ? {
        paddingLeft: index % 2 !== 0 ? '6.75rem' : '0',
        paddingRight: index % 2 === 0 ? '8.063rem' : '0',
        flexDirection: 'column',
      } : {}
    }
    
    return isDesktop ? {
      paddingRight: '0', 
      paddingLeft: '8.063rem', 
    } : {};
  };

  const getContainerStyle = () => {
    return isDesktop ? {
      flexDirection: 'row-reverse', 
    } : {};
  };

  return (
    <>
      <div className='programs-container'>
        <div className='programs-container-header'>
          {showTitle && <h2>{programsTitle}</h2>}
          {programsSubtitle &&
            <p>{programsSubtitle}</p>
          }
        </div>
        {programsIntro &&
          <div className='text-justify'>
            <RichText render={programsIntro} />
            <br/>
          </div>  
        }
        
        

        {programs?.map((program, i) => (
          <div key={nanoid()}>
            <Program
              alternatePosition={alternatePosition}
              content={program.item} isDesktop={isDesktop}
              showTitle={showInformationCardTitle}
              flexDirection={alternatePosition ? i % 2 !== 0 ? getContainerStyle() : {} : {}}
              infoContainerStyle={getInfoContainerStyle(i)}
            />
            {i + 1 !== programs.length && <hr />}
          </div>
        ))}
      </div>
      <style jsx>{`
        div.programs-container {
          text-align: center;
        }

        div.programs-container h4 {
          font-family: ${theme.fontFamilies.montserratBold};
          line-height: 1.875rem;
          margin-block-start: 0;
          margin-block-end: 5rem;
          margin-inline-start: 0;
          margin-inline-end: 0;
          margin-bottom: 1rem;
          font-weight: bold;
        }

        div.programs-container .programs-container-header {
          margin-bottom: 4rem;
        }

        div.programs-container .programs-container-header h6 {
          font-size: 1.5rem;   
        }

        div.programs-container hr {
          margin-block-start: 5rem;
          margin-block-end: 5rem;
          margin-inline-start: 0;
          margin-inline-end: 0;
        }

        @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
          div.programs-container h4 {
            line-height: 3.75rem;
          }
        }
      `}</style>
    </>
  );
};

export default Programs;
